import { useState } from 'react'
import produce from 'immer'
import { Wrapper, Sections, Section, SectionLabel, SectionContent, SectionWrapper, InputGroup, Label, Input, Select, Checkbox, Buttons, Button } from './styled'

const Col = ({ data, colIdx, setCols, setSettingsDraft }) => {
  const [values, setValues] = useState(data)

  const onChange = (key, value) => {
    setValues({ ...values, [key]: value })
  }

  const save = () => {
    setCols(produce(draft => {
      draft[colIdx] = { ...data, ...values }
    }))

    setSettingsDraft(null)
  }

  const { title = '', thAlign = 'center', tdAlign = 'center', colors = 'default', background = '', color = '', type = 'number', format = 'float', round = '', prefix = '', suffix = '', disabled = false, hidden = false, shrink = false } = values

  return (
    <Wrapper>
      <Sections>
        <SectionWrapper>
          <Section>
            <SectionLabel>Column settings</SectionLabel>
            <SectionContent>
              <InputGroup>
                <Label>Title</Label>
                <Input value={title} onChange={e => onChange('title', e.target.value)} />
              </InputGroup>
              <InputGroup>
                <Label>Alignment</Label>
                <Select value={thAlign} onChange={e => onChange('thAlign', e.target.value)}>
                  <option value="left">Left</option>
                  <option value="center">Center</option>
                  <option value="right">Right</option>
                </Select>
              </InputGroup>
              <InputGroup>
                <Label>Colors</Label>
                <Select value={colors} onChange={e => onChange('colors', e.target.value)}>
                  <option value="default">Default</option>
                  <option value="custom">Custom</option>
                </Select>
              </InputGroup>
              {
                colors === 'custom' && (
                  <>
                    <InputGroup>
                      <Label>Background color</Label>
                      <Input type="color" value={background} onChange={e => onChange('background', e.target.value)} />
                    </InputGroup>
                    <InputGroup>
                      <Label>Text color</Label>
                      <Input type="color" value={color} onChange={e => onChange('color', e.target.value)} />
                    </InputGroup>
                  </>
                )
              }
            </SectionContent>
          </Section>
        </SectionWrapper>
        <SectionWrapper>
          <Section>
            <SectionLabel>Row settings</SectionLabel>
            <SectionContent>
              <InputGroup>
                <Label>Type</Label>
                <Select value={type} onChange={e => onChange('type', e.target.value)}>
                  <option value="text">Text</option>
                  <option value="number">Number</option>
                  <option value="date">Date</option>
                </Select>
              </InputGroup>
              {
                type === 'number' && (
                  <InputGroup>
                    <Label>Format</Label>
                    <Select value={format} onChange={e => onChange('format', e.target.value)}>
                      <option value="float">Float</option>
                      <option value="decimal">Decimal</option>
                      <option value="integer">Integer</option>
                    </Select>
                  </InputGroup>
                )
              }
              {
                type === 'number' && format === 'integer' && (
                  <InputGroup>
                    <Label>Round</Label>
                    <Select value={round} onChange={e => onChange('round', e.target.value)}>
                      <option value="">Default</option>
                      <option value="up">Up</option>
                      <option value="down">Down</option>
                    </Select>
                  </InputGroup>
                )
              }
              <InputGroup>
                <Label>Alignment</Label>
                <Select value={tdAlign} onChange={e => onChange('tdAlign', e.target.value)}>
                  <option value="left">Left</option>
                  <option value="center">Center</option>
                  <option value="right">Right</option>
                </Select>
              </InputGroup>
              <InputGroup>
                <Label>Prefix</Label>
                <Input value={prefix} onChange={e => onChange('prefix', e.target.value)} />
              </InputGroup>
              <InputGroup>
                <Label>Suffix</Label>
                <Input value={suffix} onChange={e => onChange('suffix', e.target.value)} />
              </InputGroup>
              <InputGroup>
                <Checkbox id="disabled" checked={disabled} onChange={e => onChange('disabled', !disabled)} />
                <Label htmlFor="disabled" float>Disabled</Label>
              </InputGroup>
              <InputGroup>
                <Checkbox id="hidden" checked={hidden} onChange={e => onChange('hidden', !hidden)} />
                <Label htmlFor="hidden" float>Hidden</Label>
                {
                  hidden && (
                    <>
                      <Checkbox id="shrink" checked={shrink} onChange={e => onChange('shrink', !shrink)} style={{ marginLeft: '8px' }} />
                      <Label htmlFor="shrink" float>Shrink</Label>
                    </>
                  )
                }
              </InputGroup>
            </SectionContent>
          </Section>
        </SectionWrapper>
      </Sections>
      <Buttons>
        <Button onClick={() => setSettingsDraft(null)}>Cancel</Button>
        <Button onClick={save}>Save</Button>
      </Buttons>
    </Wrapper>
  )
}

export default Col